module.exports = __webpack_public_path__ + "assets/github.a1e0a262.svg";